<template>
	<el-dialog title="微信快捷登录" :append-to-body="true" :visible.sync="centerDialogVisible" width="800px" center>
		<div class="dialog-content">
			<div class="left">
				<img :src="require('@/assets/auth/img.png')" />
			</div>
			<div class="right" v-if="mode===1">
				<div class="content">
					<el-input v-model="phone" placeholder="请输入电话号码"></el-input>
					<div class="code">
						<el-input v-model="code" placeholder="请输入验证码"></el-input>
						<el-button type="primary" plain @click="getCode">获取验证码</el-button>
					</div>
				</div>
				<el-button type="primary" @click="accountLogin">账号登录</el-button>
				<el-button plain @click="changeMode(2)"><i class="el-icon-sort">微信快捷登录</i></el-button>
			</div>
			<div class="right" v-if="mode===2">
				<div class="content" id="wechat-qrcode">
					<!-- <img :src="require('@/assets/auth/qr.png')"/>-->
				</div>
				<!--        <el-button plain @click="changeMode(1)"><i class="el-icon-sort">账号登录</i></el-button>-->
			</div>
		</div>
		<!-- <BindDialog ref="bindRef" @onSuccess="bindSuccess" @onClose="bindClose" /> -->
	</el-dialog>
</template>
<script>
	// 暂时只实现了微信二维码登录，手机号登录及手机号检查及绑定都未实现
	// import BindDialog from "./bindDialog.vue";

	export default {
		name: "loginDialog",
		components: {
			// BindDialog
		},
		data() {
			return {
				centerDialogVisible: false,
				mode: 2, //1-账号密码；2-微信登录
				phone: '',
				code: ''
			};
		},
		mounted() {},
		methods: {
			onOpen() {
				this.centerDialogVisible = true;
				this.initWxLogin();
			},
			onClose() {
				this.centerDialogVisible = false;
			},
			changeMode(val) {
				console.log("changeMode = ", val);
				this.mode = val;
			},
			initWxLogin() {
				console.log("initWxLogin", this.$route);
				const path = this.$route.path;
				const query = this.$route.query;
				const searchParams = new URLSearchParams(query);
				const script = document.createElement('script');
				script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
				script.onload = () => {
					new WxLogin({
						id: "wechat-qrcode",
						appid: "wx256b1492a5969f39",
						scope: "snsapi_login",
						redirect_uri: encodeURIComponent(`https://yuzhileyouke.cn${path}?${searchParams.toString()}`),
						state: Date.now().toString(36),
						href: 'https://yuzhileyouke.cn/loginWx.css',
						callback: function(res) {
							console.log("new WxLogin callback", res.code); // 获取登录码
						}
					});
				};
				document.body.appendChild(script);
			},
			getCode() {
				this.$refs.bindRef.onOpen();
			},
			accountLogin() {
				alert("敬请期待！！")
			},
			bindSuccess() {

			},
			bindClose() {}
		}
	};
</script>
<style scoped lang="scss">
	* {
		margin: 0;
		padding: 0;
	}


	::v-deep .el-dialog {
		border-radius: 20px;
		height: 400px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: calc(50vh - 200px) !important;

		.el-dialog__header .el-dialog__title {
			font-weight: bold;
		}

		.dialog-content {
			padding-bottom: 20px;
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: center;

			.left {
				width: 55%;
				height: 260px;
				overflow: hidden;
				border-radius: 10px;

				img {
					width: 100%;
					mask-image: linear-gradient(to right, white, white, white, transparent);
				}

			}

			.right {
				width: 45%;
				height: 260px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				.content {
					width: 100%;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;

					.el-input {
						width: 260px;
					}

					.code {
						margin-top: 15px;
						width: 100%;
						display: flex;
						justify-content: space-between;
						align-items: center;

						.el-input {
							width: 160px;
						}

						.el-button {
							margin: 0;
							width: 100px;
							height: 40px;
						}
					}

					>iframe {}
				}

				.el-button {
					margin-top: 20px;
					margin-left: 0;
					width: 260px;
					height: 34px;
				}

				.el-button--default {
					border-color: transparent;
				}
			}
		}
	}
</style>